import termsText from '@/features/auth/legal/terms.txt?raw';
import privacyText from '@/features/auth/legal/privacy.txt?raw';
import refundText from '@/features/auth/legal/refund.txt?raw';
import privacyConsentText from '@/features/auth/legal/privacy-consent.txt?raw';

/**
 * 법무 문서 단일 소스이자 **버전 정본**.
 *
 * - 본문은 가입 동의 단계와 *동일한* txt 를 재사용한다 (중복/불일치 방지).
 * - `version` 은 구매 동의 스냅샷으로 서버에 그대로 전송되어 그대로 기록된다.
 *   사용자가 읽은 것은 여기 번들된 txt 이므로, 버전도 이 파일이 말해야 기록이
 *   진실이 된다. 서버는 "아는 버전인가"만 검증한다.
 *
 * ⚠️ txt 본문을 고치면 **같은 커밋에서** version 을 올린다. 본문만 바꾸면 동의
 *    기록이 조용히 거짓이 된다.
 * ⚠️ version 을 올리기 전에 platform-api `LEGAL_DOCUMENTS[].accepted` 에 새 버전을
 *    먼저 추가·배포해야 한다. 순서가 뒤집히면 그 사이 구매가 전부 400 이 된다.
 */
export const LEGAL_DOCS = {
  terms: {
    title: '이용약관',
    version: '2026-12-01',
    body: termsText,
  },
  privacy: {
    title: '개인정보 처리방침',
    version: '2026-12-01',
    body: privacyText,
    // 가입·재동의 화면의 수집·이용 동의 고지문. 처리방침과 같은 판이라 본문과 함께 고친다.
    consentNotice: privacyConsentText,
  },
  refund: {
    title: '환불·해지 정책',
    version: '2026-12-01',
    body: refundText,
  },
} as const;

export type LegalDocKey = keyof typeof LEGAL_DOCS;

export interface ConsentedDocument {
  key: LegalDocKey;
  version: string;
}

/**
 * 구독 청약(구매) 시 동의가 필요한 문서.
 * 서버 `PURCHASE_CONSENT_KEYS` 와 **같은 집합**이어야 한다. 어긋나면 결제가 400 이다.
 */
export const PURCHASE_CONSENT_KEYS = ['terms', 'refund'] as const;

/** 구매 요청에 실어 보낼 동의 스냅샷. */
export const purchaseConsentPayload = (): ConsentedDocument[] =>
  PURCHASE_CONSENT_KEYS.map((key) => ({
    key,
    version: LEGAL_DOCS[key].version,
  }));
